import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertModalComponent } from '../shared/alert-modal/alert-modal.component';

@Injectable({
    providedIn: 'root'
})

export class AlertModalService {
    private modalRef?: NgbModalRef;

    constructor(private modalService: NgbModal) {}

    openAlert(message: string, confirmCallback?: () => void, cancelCallback?: () => void): void {
        this.modalRef = this.modalService.open(AlertModalComponent);
        const modalInstance = this.modalRef.componentInstance as AlertModalComponent;
        modalInstance.message = message;

        if (confirmCallback) {
            modalInstance.confirm.subscribe(() => {
                confirmCallback();
                this.closeAlert();
            });
        }

        modalInstance.close.subscribe(() => {
            if (cancelCallback) { cancelCallback(); }
            this.closeAlert();
        });
    }

    closeAlert(): void {
        if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = undefined;
        }
    }
}
